import { CInput } from '@coreui/react';
import * as React from 'react';

export interface IValue {
	Value: string;
}

interface IProps {
	visible: boolean;
	ctrl: IValue;
	onChange: (value: string) => void;
	onMouseLeave: () => void;
	separator: ':' | '.' | "/" | " ";
}

// Pavé numérique affiché when on clique sur le bouton "..." à côté des zones pouvant recevoir un pavé numérique
export class KNumKeypad extends React.Component<IProps> {
	public constructor(props: any) {
		super(props);
	}

	onClick = (e: any, Key: string) => {
		e.stopPropagation();

		if (this.props.ctrl.Value == undefined) this.props.ctrl.Value = "";
		let val = this.props.ctrl.Value;

		switch (Key) {
			case "-":
				this.props.ctrl.Value = (- Number(this.props.ctrl.Value)).toString();
				break; 
			case "D":
				this.props.ctrl.Value = val.substr(0, val.length - 1);
				break;

			case "X":
				this.props.ctrl.Value = "";
				break;

			case "V":
				if (this.props.onMouseLeave) this.props.onMouseLeave();
				break;

			case "A":
				break;

			default:
				let newval = this.props.ctrl.Value += Key;
				let values = newval.split(".");

				// Si le numérique comporte un décimal, on traite différemment
				if (values.length == 1) {
					// Conversion string > number > string pour supprimer les 0 en trop
					this.props.ctrl.Value = Number(values[0]).toString();
				}
				else {
					this.props.ctrl.Value = Number(values[0]).toString()+ "." + values[1];
				}

				break;
		}

		if (this.props.onChange) this.props.onChange(this.props.ctrl.Value);

	}

	onMouseLeave = () => {
		this.props.ctrl.Value = Number(this.props.ctrl.Value).toString();
		if (this.props.onMouseLeave) this.props.onMouseLeave();
	}

	render() {
		if (!this.props.visible) return null;

		return (
			<div className="KNumKeypadWrapper" onClick={this.onMouseLeave} onMouseLeave={this.onMouseLeave}>
				<div className="KNumKeypad" onMouseLeave={this.onMouseLeave}>

					<CInput readOnly value={this.props.ctrl.Value}></CInput>

					<div className="btn" onClick={(e) => this.onClick(e, "7")}>7</div>
					<div className="btn" onClick={(e) => this.onClick(e, "8")}>8</div>
					<div className="btn" onClick={(e) => this.onClick(e, "9")}>9</div>
					<div className="btn" onClick={(e) => this.onClick(e, "D")}>🠴</div>
					<div></div>
					<div className="btn" onClick={(e) => this.onClick(e, "4")}>4</div>
					<div className="btn" onClick={(e) => this.onClick(e, "5")}>5</div>
					<div className="btn" onClick={(e) => this.onClick(e, "6")}>6</div>
					<div className="btn" onClick={(e) => this.onClick(e, "X")}>C</div>
					<div></div>
					<div className="btn" onClick={(e) => this.onClick(e, "1")}>1</div>
					<div className="btn" onClick={(e) => this.onClick(e, "2")}>2</div>
					<div className="btn" onClick={(e) => this.onClick(e, "3")}>3</div>
					<div className="btn" onClick={(e) => this.onClick(e, "-")}>±</div>
					<div></div>
					<div className="btn" onClick={(e) => this.onClick(e, "0")}>0</div>
					<div className="btn" onClick={(e) => this.onClick(e, this.props.separator)}>{this.props.separator}</div>
					<div className="btn" onClick={(e) => this.onClick(e, "V")}>↵</div>
				</div>
			</div>
		);
	}
}
